import "../widget-form/widget-form.css";
import "react-day-picker/lib/style.css";

import React, { SetStateAction, useContext, useEffect, useState } from "react";
import { Row, Form, Button, Modal, Col, FormControl } from "react-bootstrap";
import reactMoment from "react-day-picker/moment";
import { Modifier } from "react-day-picker";
import DayPickerInput from "react-day-picker/DayPickerInput";
import { WidgetContext } from "../../../../context/WidgetContext";
import ViewPort from "../../../../_helpers/Enums/ViewPortEnum";
import { MobileDayPickerOverlay } from "../assets/MobileDayPickerOverlay";
import moment from "moment";
import CustomDayPickerInput from "../../customDayPickerInput/CustomDayPickerInput";

export interface DatesAndGuests {
  fromDate: Date;
  toDate: Date;
  fromTime?: string;
  toTime?: string;
  guests: number;
  units: number;
}

interface props {
  brands: any[];
  datesAndGuestsState: [DatesAndGuests, React.Dispatch<SetStateAction<DatesAndGuests>>];
  onSetValidation: React.Dispatch<SetStateAction<boolean>>;
  onSetBrandId: React.Dispatch<SetStateAction<number>>;
  onWidgetButtonPressed: (button: string) => void;
  itineraryNotEmpty: boolean;
}

const WidgetForm: React.FC<props> = (props) => {
  const { startWidget, style, viewPortBreakPoint, /* brandId */brand, vendorGuid } = useContext(WidgetContext);

  const {
    brands,
    itineraryNotEmpty,
    onWidgetButtonPressed,
    onSetValidation,
    onSetBrandId,
  } = props;

  const { formatDate, parseDate } = reactMoment;
  const [datesAndGuests, setDatesAndGuests] = props.datesAndGuestsState;
  // const [brandId, setBrandId] = useState<number | undefined>(brands.length > 0 ? brands[0].brandId : undefined);
  // useEffect(() => {
  //   console.log("brandId", brandId);
  // }, [brandId]);

  const modifiers = { start: datesAndGuests.fromDate, end: datesAndGuests.toDate };
  const [errors, setErrors] = useState<any[]>([]);

  const onBrandIdChanged = (event: any) => {
    // if (+event.target.value > 0)
    // setBrandId(+event.target.value);
    onSetBrandId(+event.target.value);
  }

  const onGuestsInputChanged = (event: any) => {
    datesAndGuests.guests = +event.target.value;
    setDatesAndGuests({ ...datesAndGuests });
  }

  const onSubmit = (event: any) => {
    const dateErrors = getDateErrors();
    const brandErrors = getBrandErrors();
    setErrors([...dateErrors, ...brandErrors]);
    event.preventDefault();
  }

  function getDateErrors() {
    const errs: any[] = [];
    if (datesAndGuests.fromDate == undefined) {
      errs.push({
        id: "fromDate",
        message: "Invalid date"
      });
    }
    if (datesAndGuests.toDate == undefined) {
      errs.push({
        id: "toDate",
        message: "Invalid date"
      });
    }

    return errs;
  }

  function getBrandErrors() {
    const errs: any[] = [];

    // if (brandId == undefined) {
    //   errs.push({
    //     id: "brandId",
    //     message: "Required"
    //   });
    // }
    if (brand === undefined) {
      errs.push({
        id: "brandId",
        message: "Required"
      });
    }

    return errs;
  }

  useEffect(() => {
    setErrors(getDateErrors());
  }, [datesAndGuests]);

  useEffect(() => {
    if (errors.length > 0)
      onWidgetButtonPressed("");
    onSetValidation(errors.length == 0);
  }, [errors]);

  useEffect(() => {
    if (brand === undefined) return;

    const brandIndex = errors.findIndex(e => e.id == "brandId");
    if (brandIndex > -1)
      setErrors(errors.filter(e => e.id != "brandId"));

    if (onSetBrandId) onSetBrandId(brand?.brandId);
  }, [brand]);

  return (
    <React.Fragment>
      <Form className="w-100" onSubmit={onSubmit}>
        {/* Desktop */}
        <div className="d-none d-md-block mt-2">
          <Row className="align-items-end">
            {/* DESTINATION SELECT */}
            <div className="d-flex flex-column" style={{ marginRight: "10px" }}>
              <Form.Label className="font-weight-bold" style={{ color: style.fontColor }}>
                Destination{errors.length > 0 && errors.find(e => e.id == "brandId") && (
                  <span className="small font-italic text-danger"> {errors.find(e => e.id == "brandId").message}</span>
                )}
              </Form.Label>
              <Form.Control
                as="select"
                style={{ color: style.fontColor }}
                className="destination-select"
                // defaultValue={`${(brands.length > 1 ? undefined : brandId)}`}
                value={`${brand?.brandId}`}
                onChange={onBrandIdChanged}
                readOnly={itineraryNotEmpty}
                disabled={itineraryNotEmpty}
              >
                {brands.length > 1 && (
                  <option hidden value={-1} key="destination-default">Select Destination</option>
                )}
                {/* <option selected value={-1} key="destination-default">Select Destination</option> */}
                {brands.sort((a: any, b: any) => {
                  if (a.webOrder < b.webOrder) return -1;
                  if (a.webOrder > b.webOrder) return 1;
                  return 0
                })
                  .map((brand: any, index: number) => (
                  <option key={`${"brand"}-${"index"}-${index}`} value={brand.brandId}>
                    {brand.brandName}
                  </option>
                ))}
              </Form.Control>
            </div>

            {/* DAY PICKERS */}
            <div className="InputFromTo" style={{ marginRight: "10px" }}>
              <Col className="d-flex flex-column">
                <Form.Label className="font-weight-bold" style={{ color: style.fontColor }}>
                  Arrive{errors.length > 0 && errors.find(e => e.id == "fromDate") && (
                    <span className="small font-italic text-danger"> {errors.find(e => e.id == "fromDate").message}</span>
                  )}
                </Form.Label>
                <CustomDayPickerInput
                  value={moment(datesAndGuests.fromDate).format("ddd, MMM Do, YYYY")}
                  placeholder="From"
                  format="LL"
                  formatDate={formatDate}
                  parseDate={parseDate}
                  inputProps={{ required: "required", style: { color: style.fontColor } }}
                  // style={{ color: style.fontColor }}
                  dayPickerProps={{
                    selectedDays: { from: datesAndGuests.fromDate, to: datesAndGuests.toDate } as Modifier,
                    disabledDays: { before: new Date() },
                    modifiers,
                    numberOfMonths: 1,
                    month: datesAndGuests.fromDate,
                  }}
                  onDayChange={(date: Date) => {
                    datesAndGuests.fromDate = date;
                    if (datesAndGuests.toDate && date > datesAndGuests.toDate) {
                      datesAndGuests.toDate = date;
                    }
                    setDatesAndGuests({ ...datesAndGuests });
                  }}
                />
              </Col>
            </div>

            <div className="InputFromTo" style={{ marginRight: "10px" }}>
              <Col className="d-flex flex-column">
                <Form.Label className="font-weight-bold" style={{ color: style.fontColor }}>
                  Depart{errors.length > 0 && errors.find(e => e.id == "toDate") && (
                    <span className="small font-italic text-danger"> {errors.find(e => e.id == "toDate").message}</span>
                  )}
                </Form.Label>

                <CustomDayPickerInput
                  value={moment(datesAndGuests.toDate).format("ddd, MMM Do, YYYY")}
                  placeholder="To"
                  format="LL"
                  formatDate={formatDate}
                  parseDate={parseDate}
                  inputProps={{ required: "required", style: { color: style.fontColor } }}
                  dayPickerProps={{
                    selectedDays: { from: datesAndGuests.fromDate, to: datesAndGuests.toDate } as Modifier,
                    disabledDays: { before: datesAndGuests.fromDate as Date },
                    modifiers,
                    month: datesAndGuests.fromDate,
                    fromMonth: datesAndGuests.fromDate,
                    numberOfMonths: 1
                  }}
                  onDayChange={(date: Date) => {
                    datesAndGuests.toDate = date;
                    setDatesAndGuests({ ...datesAndGuests });
                  }}
                />
              </Col>
            </div>

            {/* GUEST SELECT */}
            <div className="widget-select-form" style={{ marginRight: "10px" }}>
              <Form.Label className="font-weight-bold" style={{ color: style.fontColor }}>
                Guests
              </Form.Label>
              <Form.Control style={{ color: style.fontColor }} as="select" onChange={onGuestsInputChanged} defaultValue={"2"}>
                <option value={"1"}>1</option>
                <option value={"2"}>2</option>
                <option value={"3"}>3</option>
                <option value={"4"}>4</option>
                <option value={"5"}>5</option>
                <option value={"6"}>6</option>
                <option value={"7"}>7</option>
                <option value={"8"}>8</option>
                <option value={"9"}>9</option>
                <option value={"10"}>10</option>
                <option value={"11"}>11</option>
                <option value={"12"}>12</option>
                <option value={"13"}>13</option>
                <option value={"14"}>14</option>
                <option value={"15"}>15</option>
                <option value={"16"}>16</option>
              </Form.Control>
            </div>
          </Row>

          {/* <Row className="widget-form-buttons" style={{ marginTop: "20px" }}>
            {startWidget.showLodgingButton && (
              <Button
                type="submit"
                onClick={() => onWidgetButtonPressed("add-lodging")}
                style={{
                  borderRadius: ".25rem",
                  backgroundColor: style.buttonColor,
                }}
              >
                + Lodging
              </Button>
            )}
            {startWidget.showGolfButton && (
              <Button
                type="submit"
                onClick={() => onWidgetButtonPressed("add-golf")}
                style={{
                  borderRadius: ".25rem",
                  backgroundColor: style.buttonColor,
                }}
              >
                + Golf
              </Button>
            )}
            {startWidget.showTransportationButton && (
              <Button
                type="submit"
                onClick={() => onWidgetButtonPressed("add-transportation")}
                style={{
                  fontSize: "14.75px",
                  borderRadius: ".25rem",
                  backgroundColor: style.buttonColor,
                }}
              >
                + Transport
              </Button>
            )}
            {startWidget.showExtrasButton && (
              <Button
                type="submit"
                onClick={() => onWidgetButtonPressed("add-custom")}
                style={{
                  borderRadius: ".25rem",
                  backgroundColor: style.buttonColor,
                }}
              >
                + Extras
              </Button>
            )}
          </Row> */}
        </div>

        {/* Mobile */}
        <Col xs={12} className="d-md-none justify-content-center align-items-center m-0 p-0">
          <div>
            <Row className="w-100 mt-2">
              {/* <Col className="w-100">
                  <Form.Label className="w-100 font-weight-bold text-right pt-2 pr-3" style={{ color: style.fontColor }}>
                    Destination:
                  </Form.Label>
                </Col> */}
              <Col xs={12}>
                <Form.Control
                  style={{ color: style.fontColor }}
                  as="select"
                  className="w-100"
                  // defaultValue={`${brandId}`}
                  value={`${brand?.brandId}`}
                  onChange={onBrandIdChanged}
                >
                  {brands.length > 1 && (
                    <option hidden disabled key="destination-default" value={-1}>Select Destination</option>
                  )}
                  {brands.map((brand: any, index: number) => (
                    <option key={`${"brand"}-${"index"}-${index}`} value={brand.brandId}>
                      {brand.brandName}
                    </option>
                  ))}
                </Form.Control>
                {errors.length > 0 && errors.find(e => e.id == "brandId") && (
                  <span className="small font-italic text-danger"> {errors.find(e => e.id == "brandId").message}</span>
                )}
              </Col>
            </Row>
            <Row className="mobile InputFromTo mt-3">
              {/* <Col className="w-100">
                  <Form.Label className="w-100 font-weight-bold text-right pt-2 pr-3" style={{ color: style.fontColor }}>
                    Arrive:
                  </Form.Label>
                </Col> */}
              <Col xs={12}>
                <CustomDayPickerInput
                  overlayComponent={MobileDayPickerOverlay}
                  inputProps={{ readOnly: true, style: { color: style.fontColor } }}
                  value={`Arrive: ${moment(datesAndGuests.fromDate).format("ddd, MMM Do, YYYY")}`}
                  placeholder="Arrive"
                  format="LL"
                  formatDate={formatDate}
                  parseDate={parseDate}
                  dayPickerProps={{
                    selectedDays: { from: datesAndGuests.fromDate, to: datesAndGuests.toDate } as Modifier,
                    disabledDays: { before: new Date() },
                    month: datesAndGuests.fromDate,
                    numberOfMonths: 1,
                    modifiers,
                  }}
                  onDayChange={(date: Date) => {
                    datesAndGuests.fromDate = date;
                    if (datesAndGuests.toDate && date > datesAndGuests.toDate) {
                      datesAndGuests.toDate = date;
                    }
                    setDatesAndGuests({ ...datesAndGuests });
                  }}
                />
                {errors.length > 0 && errors.find(e => e.id == "fromDate") && (
                  <div className="m-0 p-0">
                    <span className="small font-italic text-danger"> {errors.find(e => e.id == "fromDate").message}</span>
                  </div>
                )}

              </Col>
            </Row>
            <Row className="mobile InputFromTo mt-3">
              <Col xs={12}>
                <CustomDayPickerInput
                  overlayComponent={MobileDayPickerOverlay}
                  inputProps={{ readOnly: viewPortBreakPoint <= ViewPort.sm, required: "required", style: { color: style.fontColor } }}
                  value={`Depart: ${moment(datesAndGuests.toDate).format("ddd, MMM Do, YYYY")}`}
                  placeholder="To"
                  format="LL"
                  formatDate={formatDate}
                  parseDate={parseDate}
                  dayPickerProps={{
                    selectedDays: { from: datesAndGuests.fromDate, to: datesAndGuests.toDate } as Modifier,
                    disabledDays: { before: new Date() },
                    modifiers,
                    month: datesAndGuests.fromDate,
                    numberOfMonths: 1
                  }}
                  onDayChange={(date: Date) => {
                    datesAndGuests.toDate = date;
                    if (datesAndGuests.fromDate && date < datesAndGuests.fromDate) {
                      datesAndGuests.fromDate = date;
                    }
                    setDatesAndGuests({ ...datesAndGuests });
                  }}
                />
                {errors.length > 0 && errors.find(e => e.id == "toDate") && (
                  <div className="m-0 p-0">
                    <span className="small font-italic text-danger"> {errors.find(e => e.id == "toDate").message}</span>
                  </div>
                )}

              </Col>
            </Row>

            {/* GUEST/CHILD SELECT */}
            <Row className="w-100 mt-3">
              {/* <Col xs={2}>
                  <Form.Label className="w-100 font-weight-bold text-left pt-2" style={{ color: style.fontColor }}>
                    Guests:
                  </Form.Label>
                </Col> */}
              <Col xs={12}>
                <Row className="justify-content-start">
                  <Form.Control 
                    style={{ 
                      color: style.fontColor, 
                      fontSize: "16px", 
                      width: "100%", 
                      paddingLeft: "6px" 
                    }} 
                    className="guest-select" 
                    as="select"
                    onChange={(e: any) => {
                      onGuestsInputChanged(e);
                    }}
                    defaultValue={"2"}
                  >
                    <option value={"1"}>Guests: 1</option>
                    <option value={"2"}>Guests: 2</option>
                    <option value={"3"}>Guests: 3</option>
                    <option value={"4"}>Guests: 4</option>
                    <option value={"5"}>Guests: 5</option>
                    <option value={"6"}>Guests: 6</option>
                    <option value={"7"}>Guests: 7</option>
                    <option value={"8"}>Guests: 8</option>
                    <option value={"9"}>Guests: 9</option>
                    <option value={"10"}>Guests: 10</option>
                    <option value={"11"}>Guests: 11</option>
                    <option value={"12"}>Guests: 12</option>
                    <option value={"13"}>Guests: 13</option>
                    <option value={"14"}>Guests: 14</option>
                    <option value={"15"}>Guests: 15</option>
                    <option value={"16"}>Guests: 16</option>
                    <option value={"80"}>Guests: 80</option>
                  </Form.Control>
                </Row>
              </Col>
              <Col xs={12}>
                {false && (
                  <Row className="justify-content-end">
                    <Form.Label className="font-weight-bold pt-2 pr-3" style={{ color: style.fontColor }}>
                      Child:
                    </Form.Label>
                    <Form.Control as="select" style={{ width: "65px" }} onChange={() => { }} defaultValue={"0"}>
                      <option value={"1"}>1</option>
                      <option value={"2"}>2</option>
                      <option value={"3"}>3</option>
                      <option value={"4"}>4</option>
                      <option value={"5"}>5</option>
                      <option value={"6"}>6</option>
                      <option value={"7"}>7</option>
                      <option value={"8"}>8</option>
                      <option value={"9"}>9</option>
                      <option value={"10"}>10</option>
                      <option value={"11"}>11</option>
                      <option value={"12"}>12</option>
                      <option value={"13"}>13</option>
                      <option value={"14"}>14</option>
                      <option value={"15"}>15</option>
                      <option value={"16"}>16</option>
                    </Form.Control>
                  </Row>
                )}
              </Col>
            </Row>
          </div>

          {/* <div className="d-flex flex-column justify-content-center mt-4">
            {startWidget.showLodgingButton && (
              <Button
                type="submit"
                onClick={() => onWidgetButtonPressed("add-lodging")}
                style={{
                  borderRadius: ".25rem",
                  backgroundColor: style.buttonColor,
                  marginBottom: "15px",
                  border: "none",
                }}
              >
                + Lodging
              </Button>
            )}
            {startWidget.showGolfButton && (
              <Button
                type="submit"
                onClick={() => onWidgetButtonPressed("add-golf")}
                style={{
                  borderRadius: ".25rem",
                  backgroundColor: style.buttonColor,
                  marginBottom: "15px",
                  border: "none",
                }}
              >
                + Golf
              </Button>
            )}
            {startWidget.showTransportationButton && (
              <Button
                type="submit"
                onClick={() => onWidgetButtonPressed("add-transportation")}
                style={{
                  fontSize: "16.75px",
                  borderRadius: ".25rem",
                  backgroundColor: style.buttonColor,
                  marginBottom: "15px",
                  border: "none",
                }}
              >
                + Transport
              </Button>
            )}
            {startWidget.showExtrasButton && (
              <Button
                type="submit"
                onClick={() => onWidgetButtonPressed("add-custom")}
                style={{
                  borderRadius: ".25rem",
                  backgroundColor: style.buttonColor,
                  marginBottom: "15px",
                  border: "none",
                }}
              >
                + Extras
              </Button>
            )}
          </div> */}
        </Col>
      </Form>
    </React.Fragment>
  );
}

export default WidgetForm;
